import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Permission} from '../../../common/model/permission.enum';

@Component({
    selector: 'app-button-crud',
    template: `
    <app-buttons-layout [isModal]="isModal">

        <app-button-cancel [queryParams]="queryParams" [route]="backRoute" [fragment]="fragment" [isModal]="isModal"></app-button-cancel>

        <app-button-save [disable]="!valid" [title]="titleSave" (confirm)="onSave($event)"></app-button-save>

        <app-button-delete class="ml-auto" *ngIf="showDelete()"
          [entity]="entity"
          [showLabel]="true"
          [title]="titleDelete"
          (confirm)="onDelete($event)"
        ></app-button-delete>

      </app-buttons-layout>
  `,
    standalone: false
})
export class ButtonCrudComponent {

  @Input() backRoute = '..';

  @Input() fragment = null;

  @Input() entity;

  @Input() valid = true;

  @Input() noDelete = false;

  @Input() queryParams = {};

  @Input() isModal = false;

  @Input() titleSave = 'save';

  @Input() titleDelete = 'delete';

  @Output() save = new EventEmitter();

  @Output() delete = new EventEmitter();

  public onSave(modalRef) {
    this.save.emit(modalRef);
  }

  public onDelete(modalRef) {
    this.delete.emit(modalRef);
  }

  public showDelete() {
    return this.entity && !this.noDelete;
  }

}

